import { render, staticRenderFns } from "./BookingConvertToQuoteSimple.vue?vue&type=template&id=e82aaf4e"
import script from "./BookingConvertToQuoteSimple.vue?vue&type=script&lang=js"
export * from "./BookingConvertToQuoteSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e82aaf4e')) {
      api.createRecord('e82aaf4e', component.options)
    } else {
      api.reload('e82aaf4e', component.options)
    }
    module.hot.accept("./BookingConvertToQuoteSimple.vue?vue&type=template&id=e82aaf4e", function () {
      api.rerender('e82aaf4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/BookingConvertToQuoteSimple.vue"
export default component.exports